import { Component, OnInit } from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Vacancy} from '../models/vacancy';
import {VacancyService} from '../vacancy.service';
import {VacancyStatus} from '../models/vacancy-status.enum';

@Component({
  selector: 'app-vacancy-detail-page',
  templateUrl: './vacancy-detail-page.component.html',
  styleUrls: ['./vacancy-detail-page.component.css']
})
export class VacancyDetailPageComponent implements OnInit {

  public vacancy: Vacancy;

  constructor(private route: ActivatedRoute, private vacancyService: VacancyService) { }

  ngOnInit(): void {
    let id: string = this.route.snapshot.paramMap.get('id');
    this.vacancy = this.vacancyService.getById(parseInt(id));
  }

  public getReadableStatus(vacancy: Vacancy): string {
    switch(vacancy.status) {
      case VacancyStatus.OPEN:
        return "Open";
      case VacancyStatus.CLOSED:
        return "Closed";
    }
  }

}
